/*
  Quantity/remove handling for the custom cart-drawer item list
  (vit2go-cart-items.liquid). Uses the real Shopify AJAX Cart API
  (/cart/change.js) directly rather than Horizon's proprietary
  CartLinesUpdateEvent system, then does a full, safe re-render of the
  drawer's inner content via the Section Rendering API.

  Deliberately swaps only `.cart-drawer__inner`'s content, never the
  <dialog>/<theme-drawer> wrapper itself, so the drawer's open/closed
  state (which lives on the wrapper) is never disturbed by the refresh.
*/
(function () {
  "use strict";

  function getContainer() {
    return document.querySelector("[data-v2g-cart-items]");
  }

  function setBusy(container, busy) {
    if (container) container.setAttribute("aria-busy", busy ? "true" : "false");
  }

  function updateBubble(itemCount) {
    var counts = document.querySelectorAll(".cart-bubble__text-count");
    counts.forEach(function (el) {
      el.textContent = itemCount > 0 ? String(itemCount) : "";
    });
    var bubbles = document.querySelectorAll(".cart-bubble");
    bubbles.forEach(function (el) {
      el.classList.toggle("visually-hidden", itemCount === 0);
    });
  }

  function refreshDrawer() {
    var inner = document.querySelector(".cart-drawer__inner");
    if (!inner) return Promise.resolve();

    return fetch(window.location.pathname + "?section_id=cart-drawer-section", {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var freshInner = doc.querySelector(".cart-drawer__inner");
        var current = document.querySelector(".cart-drawer__inner");
        if (freshInner && current) {
          current.replaceWith(freshInner);
        }
      })
      .catch(function () {
        /* leave current content as-is on network failure */
      });
  }

  function changeLine(variantId, quantity) {
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + "cart/change.js"
      : "/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity }),
    }).then(function (res) {
      return res.json();
    });
  }

  function handleClick(event) {
    var decreaseBtn = event.target.closest("[data-v2g-cart-decrease]");
    var increaseBtn = event.target.closest("[data-v2g-cart-increase]");
    var removeBtn = event.target.closest("[data-v2g-cart-remove]");
    var trigger = decreaseBtn || increaseBtn || removeBtn;
    if (!trigger) return;

    var row = trigger.closest("[data-v2g-cart-line]");
    if (!row) return;

    var variantId = row.getAttribute("data-v2g-cart-variant");
    var qtyEl = row.querySelector("[data-v2g-cart-qty]");
    var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;

    var newQty = currentQty;
    if (increaseBtn) newQty = currentQty + 1;
    if (decreaseBtn) newQty = currentQty - 1;
    if (removeBtn) newQty = 0;

    var container = getContainer();
    setBusy(container, true);

    changeLine(variantId, newQty)
      .then(function (cart) {
        updateBubble(cart.item_count);
        return refreshDrawer();
      })
      .catch(function () {
        setBusy(container, false);
      });
  }

  function init(container) {
    container.addEventListener("click", handleClick);
  }

  function boot() {
    var container = getContainer();
    if (container && !container.dataset.v2gCartItemsBound) {
      container.dataset.v2gCartItemsBound = "true";
      init(container);
    }
  }

  boot();
  document.addEventListener("shopify:section:load", boot);

  // The drawer's inner content gets replaced wholesale on refresh, so
  // re-bind whenever a fresh copy shows up.
  var observer = new MutationObserver(function () {
    boot();
  });
  var drawerRoot = document.getElementById("cart-drawer");
  if (drawerRoot) {
    observer.observe(drawerRoot, { childList: true, subtree: true });
  }

  // Every product page's own "Aan winkelwagen toevoegen" button adds via
  // a plain fetch() (not Horizon's native add-to-cart-component), so
  // nothing tells this drawer a new item arrived. Each of those buttons
  // dispatches "vit2go:cart:updated" with the fresh cart on success —
  // listen for it here to update the header bubble, refresh the
  // drawer's content, and open it, matching what a customer expects to
  // see immediately after adding something to their cart.
  document.addEventListener("vit2go:cart:updated", function (event) {
    var cart = event.detail;
    if (cart && typeof cart.item_count === "number") {
      updateBubble(cart.item_count);
    }
    refreshDrawer().then(function () {
      boot();
      var drawer = document.getElementById("cart-drawer");
      if (drawer && typeof drawer.open === "function") {
        drawer.open();
      }
    });
  });
})();
